<template>
  <div v-if="open" class="landing">
    <div class="landing__upper_part">
      <img class="landing__upper_part__logo" :src="logoWhite" />
      <div class="landing__upper_part__header">
        {{ $t("landingTitle") }}
      </div>
    </div>
    <div class="landing__lower_part">
      <div class="landing__lower_part__tutorial">
        <div class="landing__lower_part__tutorial__column">
          <img
            :src="landingIcon_01"
            class="landing__lower_part__tutorial__column__img"
          />
          <p class="textBottom">
            {{ $t("landing_turorial_keyboard") }}
          </p>
        </div>
        <div class="landing__lower_part__tutorial__column">
          <img
            :src="landingIcon_02"
            class="landing__lower_part__tutorial__column__img"
          />
          <p class="textBottom">
            {{ $t("landing_turorial_mouse") }}
          </p>
        </div>
      </div>
      <div class="landing__lower_part__button" @click="closeOnClick">
        {{ $t("letsGoButton") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LandingComponent",
  data() {
    return {
      landingIcon_01: require("../assets/svgs/flechitas_orange.svg"),
      landingIcon_02: require("../assets/svgs/Mouse_icon_orange.svg"),
      logoWhite: require("../assets/svgs/logoWhite.svg"),
      open: false,
    };
  },
  beforeMount() {
    this.$root.$on("openLanding", this.openLanding);
  },
  beforeDestroy() {
    this.$root.$off("openLanding", this.openLanding);
  },
  methods: {
    openLanding() {
      this.open = true;
    },
    closeOnClick() {
      this.$root.$emit("openWelcome");

      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.landing {
  position: fixed;
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .landing__upper_part {
    display: flex;
    flex-direction: column;
    align-items: center;

    .landing__upper_part__logo {
      width: 175px;
      height: 170px;
    }

    .landing__upper_part__header {
      width: 100%;
      font-family: Unna;
      font-size: 4.5vw;
      color: white;
      text-align: center;
    }
  }

  .landing__lower_part {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1;
    justify-content: space-evenly;

    .landing__lower_part__tutorial {
      display: flex;
      width: 100vw;
      align-items: flex-start;
      justify-content: space-evenly;

      .landing__lower_part__tutorial__column {
        flex: 1 1 0;

        .landing__lower_part__tutorial__column__img {
          width: 65px;
          height: 65px;
        }

        .textBottom {
          font-family: Calibre;
          font-size: 18px;
          color: white;
          opacity: 1;
          margin: 15px;
        }
      }
    }

    .landing__lower_part__button {
      width: 202px;
      height: 43px;
      padding: 12px 28px 11px 26px !important;
      border-radius: 2px;
      background-color: #fe5b1b;
      font-family: Calibre;
      font-size: 18px;
      text-align: center;
      color: #fff !important;
      cursor: pointer;

      &:hover {
        background-color: #fe791b;
        transition: 0.2s;
      }
    }
  }
}
</style>
